
class MyTabs extends HTMLElement {
  connectedCallback() {
    const tabs = this.querySelectorAll('[data-tab]');
    const panels = this.querySelectorAll('[data-panel]');
    const container = this.querySelector('.tabs_item_contaainer');

    // ⭐ 初始化第一个 tab
    if (tabs.length > 0) {
      tabs[0].classList.add('active');
      panels[0]?.classList.add('active');

      // 可选：让第一个居中（如果你想）
      tabs[0].scrollIntoView({
        behavior: 'auto', // 初始不用动画
        inline: 'center',
        block: 'nearest'
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {

        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));

        tab.classList.add('active');
        panels[index]?.classList.add('active');

        const containerRect = container.getBoundingClientRect();

        const visibleTabs = Array.from(tabs).filter(t => {
          const r = t.getBoundingClientRect();
          return r.right > containerRect.left && r.left < containerRect.right;
        });

        const firstVisible = visibleTabs[0];
        const lastVisible = visibleTabs[visibleTabs.length - 1];
        const secondLastVisible = visibleTabs[visibleTabs.length - 2];

        if (tab === firstVisible || tab === lastVisible) {
          tab.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
          });
          return;
        }

        if (tab === secondLastVisible && lastVisible) {
          lastVisible.scrollIntoView({
            behavior: 'smooth',
            inline: 'end',
            block: 'nearest'
          });
        }
      });
    });
  }
}

customElements.define('my-tabs', MyTabs);

  